<template>
    <div class="outer">
        <div v-if="!project.recipe_id" class="container-fluid cards" id="recipes">
            <div class="row my-5">
                <div class="col-md-6 col-sm-10 mx-auto text-center">
                    <h3 class="subtitle">Please select an analysis template below. Click on "How it works" to see what
                        you can do with your data.</h3>
                </div>
            </div>
            <div class="row">
                <div class="container wide">
                    <div class="row">
                        <div class="col-lg-6 col-md-8 col-sm-12 p-0 mx-lg-0 mx-md-auto mx-sm-auto"
                             v-for="(recipe, index) in recipes" :key="index">
                            <project-recipe-card
                                v-bind:recipe="recipe"
                                v-bind:is-selected="project.recipe === recipe"
                                v-bind:index="index+1"
                                @selected="onRecipeSelected">
                            </project-recipe-card>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div v-if="selectionFinished && project.recipe" class="container">
            <div class="row">
                <select-recipe-column-and-run>
                </select-recipe-column-and-run>
            </div>
        </div>
    </div>

</template>
<script>
    import SelectRecipeColumnAndRun from "./SelectRecipeColumnAndRun";
    import {mapActions, mapGetters} from 'vuex';
    import EventBus from '../eventBus'

    export default {
        components: {SelectRecipeColumnAndRun},
        props: {
            recipes: Array
        },
        computed: {
            ...mapGetters([
                'urls',
                'projectStates',
                'project',
                'columns'
            ])
        },
        data: function () {
            return {
                stepIndex: Number,
                selectionFinished: false
            }
        },
        mounted() {
            this.stepIndex = this.project.recipe_id ? 1 : 0;
            this.selectionFinished = !!this.project.recipe_id;
            EventBus.$on('ANALYSIS_READY', (payload) => {
                this.onAnalysisReady(payload);
            });
        },
        methods: {
            ...mapActions([
                'closeModal',
                'openModal',
                'setLoading',
                'setMessage',
                'setModalLink',
                'setModalAllowClose',
                'setProject'
            ]),
            onRecipeSelected: function (recipe) {
                this.selectionFinished = false;
                let instance = this;
                this.openModal();
                this.setLoading(true);
                this.setProject({
                    ...
                    this.project,
                    state_id: this.projectStates[2].id,
                    recipe: recipe,
                    recipe_id: recipe.id
                });
                axios.post(this.urls.postProjectUrl, this.project, {headers: {'Accept': 'application/json'}})
                    .then(function (response) {
                        instance.closeModal();
                        instance.setLoading(false);
                        instance.stepIndex = 1;
                        instance.selectionFinished = true;
                    })
                    .catch(function (error) {
                        console.error(error);
                        instance.openModal();
                        instance.setLoading(false);
                    });
            },
            onAnalysisReady: function (data) {
                window.location.href = this.urls.viewProjectUrl + '/' + this.project.public_hash;
            }
        }
    }
</script>
<style lang="scss">

    @import "../../sass/variables";

    .subtitle {
        margin: 1rem auto;
        color: $blue;
    }

</style>
